import { render, staticRenderFns } from "./SystemBaseEnumData.vue?vue&type=template&id=a37a0756&scoped=true"
import script from "./SystemBaseEnumData.vue?vue&type=script&lang=js"
export * from "./SystemBaseEnumData.vue?vue&type=script&lang=js"
import style0 from "./SystemBaseEnumData.vue?vue&type=style&index=0&id=a37a0756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37a0756",
  null
  
)

export default component.exports